import React from 'react'
import { ManagedSoundList, ManagedSoundListProps, ManagedSoundListFilter } from 'bpm-sounds-generic'

export function CreateManagedSoundlist<F extends ManagedSoundListFilter>(props: ManagedSoundListProps<F>) {
    return <ManagedSoundList<F> {...props} />

}

export default CreateManagedSoundlist